import { getUserInformation, reconnect } from '../components/Login/loginService';
/**
 * Devuelve el front-end client name.
 * Emulado o real (cuando se despliega a los diferentes subtites.)
 */
export function getFEClientName() {
    let client = localStorage.getItem('x-olympia-client');
    if (!client) {
        client = process.env.REACT_APP_CLIENT_NAME || 'default';
    }
    return client;
}
/**
 * Helper method para obtener el Header Por default que necesita el backend.
 */
export function getDefaultHeader(add_access_token) {
    let client = getFEClientName();
    let header = {
        'content-type': 'application/json',
        'x-olympia-client-version': process.env.REACT_APP_BUILD_VERSION,
        'x-olympia-client': client,
    };
    if (add_access_token) {
        header['x-access-token'] = localStorage.getItem('token');
        header['Accept-Language'] = localStorage.getItem('i18nextLng');
    }
    return header;
}
/**
 * Funcion that initialize the web session.
 * <you should not call this function if you don't know what it does.>
 */
export function initWebSession(triggerEvent) {
    let websessduration = eval(process.env.REACT_APP_WEBSESSION_TIME_OUT_SECS);
    //console.log("Web Session Time Out (minutes)", websessduration / 60);
    let sessionActiveDate = new Date(new Date().getTime() + websessduration * 1000);
    window.localStorage.setItem('sessionActiveDate', sessionActiveDate.getTime());
    if (triggerEvent !== false) {
        let evv = new Event('connectionChange');
        evv.connected = oauthSessionAlive();
        window.dispatchEvent(evv);
    }
}
/**
 * kill webSession. Next request will be redirected to login.
 */
export function endWebSession() {
    window.localStorage.removeItem('sessionActiveDate');
    let evv = new Event('connectionChange');
    evv.connected = false;
    window.dispatchEvent(evv);
}
/**
 * Helper function to check if OAuth token is read to expire (helps avoid calling server if 401 will be returned)
 */
export async function oauthSessionExpired() {
    const user = getUserInformation();
    let expired = true;
    if (user) {
        let tokenExpireDate = new Date(user.exp * 1000);
        //console.log("OAUTH Session Expire:", tokenExpireDate.toLocaleString());
        let diff = (tokenExpireDate - new Date()) / 1000;
        expired = !(diff >= 0);
    }
    return new Promise(resolve => { resolve(expired); });
}
/**
 * Check session alive without Promise.
 */
export function oauthSessionAlive() {
    const user = getUserInformation();
    let expired = true;
    if (user) {
        let tokenExpireDate = new Date(user.exp * 1000);
        console.log('OAUTH Session Expire:', tokenExpireDate.toLocaleString());
        let diff = (tokenExpireDate - new Date()) / 1000;
        expired = !(diff >= 0);
    }
    return !expired;
}

/**
 * Funcion que chequea que la session web siga activa por el periodo estipulado.
 *
 *
 * @param boolean isActive set this flag to extend the session indeas of check
 */
export async function webSessionAliveCheck(isActive, dobackgroundReconnect) {
    const user = getUserInformation();
    let isalive = false;
    if (user) {
        //si el usuario esta activo lo pateo x minutos mas
        //console.log("Extend Session? ", isActive);
        if (isActive) {
            initWebSession(false);
        }
        let sessionActiveDate = new Date(parseInt(localStorage.getItem('sessionActiveDate'), 0));
        //console.log("Background Reconnect if possible? ", dobackgroundReconnect);
        if (sessionActiveDate !== 'null') {
            //console.log("WEB   Session Expire:", sessionActiveDate.toLocaleString());
            let diff = (sessionActiveDate - new Date()) / 1000;
            //console.log(diff);
            isalive = (diff >= 0);
        } else {
            isalive = false;
        }

        if (dobackgroundReconnect) {
            //puedo saber si el oauth expiro antes de hacer la llamada al server.
            const isoauthexpired = await oauthSessionExpired().then(res => {
                return res;
            });

            //console.log("OAuth Expired? ", isoauthexpired);
            //si el usuario esta conectado y expiro el oauth y puedo recontar
            if (isalive && isoauthexpired) {
                await backgroundReconnect().then(rc => {
                    console.log("   >> background reconnect success");
                    return rc;
                }).catch(error => {
                    error.json().then(res => {
                        //console.log("   >> background reconnect fail");
                        //console.log(res);
                        isalive = false;
                        //logout(res.message);
                    });
                });
            }
        }
    }
    return new Promise(resolve => { resolve(isalive); });
}

/**
 * Funcion que se encarga de validar que la session del usuario este activa desde la ultima interaccion con backend.
 * Si Expiro intenta reconectar. Si falla falla todo
 */
export async function backgroundReconnect() {
    //let auth_server = process.env.OAUTH_APP_URL;
    //call oauth con refresh token
    const user = getUserInformation();
    if (user && user.exp) {
        return reconnect();
    }
    return new Promise(resolve => { resolve(false); });
}



// WEBPACK FOOTER //
// ./src/services/serviceAPIHelper.js